import React, { useState } from "react";
import ComponentStatusIcon from "../components/ComponentStatusIcon";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { usePopup } from "../../common/contexts/PopupContext";

const MaintenanceCard = ({
  submitHandler,
  update,
  happenedAt,
  dateDiff,
  formClose,
  updatedAt,
}) => {
  const { toast } = usePopup();

  const [isHovered, setIsHovered] = useState(false);
  const [date, setDate] = useState(happenedAt?.split("T")[0]);
  const [time, setTime] = useState(happenedAt?.split("T")[1]?.slice(0, 5));
  const [isEditClicked, setIsEditClicked] = useState(formClose || false);
  const [message, setMessage] = useState(update?.message || "");
  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleEditClick = () => {
    setIsEditClicked(!isEditClicked);
  };
  const childsubmitHandler = (e) => {
    e.preventDefault();
    if (!date || !time) {
      toast("Date or Time is missing", "error");
      return;
    }
    const updatedDate = new Date(`${date}T${time}`);

    const id = update?._id;
    const maintenanceId = update?.maintenance;
    const updatedMessage = message;
    submitHandler(id, maintenanceId, updatedDate, updatedMessage);
  };

  return (
    <div
      key={update?.maintenance}
      className="bg-white dark:bg-slate-900 rounded-lg px-4 py-4 ring-1 ring-slate-900/5 shadow-sm border-2 border-t-orange-500"
    >
      <div className="buttonOp">
        <Link
          to={`/maintenance/${update?.maintenance}`}
          className="hover:bg-gray-200 rounded-md p-2 hover:text-blue-800 underline"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="blue"
            className="bi bi-pencil"
            viewBox="0 0 16 16"
            onClick={handleEditClick}
          >
            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
          </svg>
        </Link>
      </div>
      <span
        className="text-slate-900 dark:text-white mt-5 text-base font-bold tracking-tight"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {isHovered ? updatedAt : dateDiff}
      </span>
      <br />
      <p className="inline-flex items-right justify-right p-2 bg-blue-500 rounded-md shadow-sm text-white mt-5">
        {update?.status?.label}
      </p>
      <br />
      <br />
      {isEditClicked ? (
        <div className="edit-incident-update-form">
          <form className="space-y-6" onSubmit={childsubmitHandler}>
            <div className={`my-4 `}>
              <div className="pb-1 text-gray-800">Scheduled Date & Time</div>
              <input
                type="date"
                onChange={(e) => setDate(e.target.value)}
                min={moment().format("YYYY-MM-DD")}
                defaultValue={happenedAt?.split("T")[0]}
                className={`px-6 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-1/4`}
                required
              />
              <input
                type="time"
                onChange={(e) => setTime(e.target.value)}
                defaultValue={happenedAt?.split("T")[1]?.slice(0, 5)}
                className={`px-6 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-1/4`}
                required
              />
            </div>
            <div className={`my-4 `}>
              <div className="pb-1 text-gray-800">Message</div>
              <textarea
                type="text"
                className={`px-2 py-2 rounded-md border-2 border-gray-300 outline-none focus:ring-2 transition ease-in-out delay-150 w-full`}
                rows={4}
                cols={50}
                onChange={(e) => setMessage(e.target.value)}
                defaultValue={update?.message}
              />
            </div>
            <div class="actions action-buttons-aligner">
              <button
                className="cpt-button size-small style-outline color-grey"
                onClick={handleEditClick}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="cpt-button size-small style-primary"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div key={update?._id}>{update?.message}</div>
      )}
      <div>
        {update?.affectedComponents?.map((component, i) => (
          <div key={i} className="mt-3 flex items-center gap-2">
            <ComponentStatusIcon statusSlug="operational" />
            {component.componentName}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MaintenanceCard;
